import axios from "axios";
import { blobToDataUrl } from "core/blob_operations";

interface Args {
  url: string;
  headers: any;
  signal: AbortSignal;
}

export const downloadAsDataUri = async ({
  url,
  headers,
  signal
}: Args): Promise<string> => {
  const res = await axios.get(url, {
    responseType: "blob",
    headers,
    signal
  });

  return await blobToDataUrl(res.data);
};
